import { createContext, useContext, useEffect, useState } from "react";

export const messages = {
    en: {
        nav: {
            services: "Services",
            doctors: "Doctors",
            gallery: "Inside Signita",
            appointment: "Appointment",
            location: "Location",
            book: "Book Appointment",
            toggle: "मराठी",
        },
        hero: {
            eyebrow: "Signita Wellness — Thane West",
            l1a: "Expert care for",
            l1b: "skin,",
            l2a: "ear, nose",
            l2b: "& throat.",
            sub: "A specialist wellness centre led by Dr. Swapnil Bhagat (Dermatology) and Dr. Seema Gupta (ENT) — with pathology, digital ECG, general OPD and an in-house pharmacy, all under one calm roof near Oscar Hospital, Kasarvadavali.",
            cta1: "Book an appointment",
            cta2: "Call 7208991091",
            stats: [
                { v: "02", l: "Core specialities — Dermatology & ENT" },
                { v: "06", l: "OPD services under one roof" },
                { v: "01", l: "Destination, Ghodbunder Road, Thane West" },
            ],
            scroll: "Scroll",
            badge1t: "Dermatology",
            badge1s: "Our lead speciality",
            badge2t: "Also in-house",
            badge2s: "ENT · Pathology · ECG · Pharmacy",
            gReviewsWord: "Google reviews",
        },
        marquee: ["Dermatology", "Cosmetology", "ENT Care", "Pathology", "Digital 12-Lead ECG", "In-House Pharmacy", "General OPD"],
        services: {
            eyebrow: "What we do",
            h2a: "One address for skin, senses &",
            h2b: "everything diagnostic.",
            side: "Specialist consultation backed by on-site pathology, digital ECG and a stocked pharmacy — so your visit ends with answers, not errands.",
            items: {
                derm: {
                    tag: "Lead Speciality",
                    title: "Dermatology & Cosmetology",
                    desc: "Clinical dermatology, skin rejuvenation, laser procedures, acne care and hair restoration — planned by Dr. Swapnil Bhagat, MBBS, DDV.",
                    chips: ["Acne & pigmentation", "Laser & aesthetics", "Hair restoration"],
                },
                ent: {
                    tag: "Core Speciality",
                    title: "ENT — Ear, Nose & Throat",
                    desc: "Comprehensive otolaryngology care by Dr. Seema Gupta, MBBS, MS ENT, DNB ENT — for adults and children alike.",
                },
                path: {
                    tag: "Diagnostic OPD",
                    title: "Advanced Pathology",
                    desc: "Complete blood work and specialised biomarkers with quick reporting — right here in the centre.",
                },
                ecg: {
                    title: "ECG & Cardiac Screening",
                    desc: "Digital 12-lead ECG with rapid evaluation for preventive heart health.",
                },
                pharm: {
                    title: "In-House Pharmacy",
                    desc: "Genuine prescribed dermatological topicals, ENT care kits and essential medicines.",
                },
                opd: {
                    title: "General OPD",
                    desc: "Preventive health checks, expert second opinions and personalised care plans.",
                    walkin: "Walk-ins welcome",
                },
            },
        },
        why: {
            eyebrow: "Why Signita",
            h2a: "A calm, considered clinic —",
            h2b: "built around your time.",
            chipTop: "Near",
            chip: "Oscar Hospital, Kasarvadavali",
            points: [
                {
                    title: "Specialists first",
                    text: "Consultations led by qualified specialists — a dermatologist and an ENT surgeon, not general gatekeeping.",
                },
                {
                    title: "Diagnostics under one roof",
                    text: "Pathology, digital 12-lead ECG and general OPD sit beside the consultation rooms, so reports don't take days.",
                },
                {
                    title: "Easy to reach",
                    text: "Right next to Oscar Hospital on Kasarvadavali, Ghodbunder Road — with an in-house pharmacy to finish the visit.",
                },
            ],
        },
        doctors: {
            eyebrow: "Meet the doctors",
            h2a: "Two specialists.",
            h2b: "Zero guesswork.",
            hours: "Consultation hours",
            enquire: "Enquire",
            consultNote: "Walk-in & appointment",
            lead: "Lead Speciality",
            swapnil: {
                role: "Dermatologist & Cosmetologist",
                focus: ["Clinical dermatology", "Skin & hair treatments", "Laser & aesthetic procedures"],
                timings: [
                    { d: "Mon, Tue, Thu, Fri, Sat", h: "12:00 PM – 9:30 PM" },
                    { d: "Wednesday", h: "Closed", closed: true },
                    { d: "Sunday", h: "12:00 PM – 7:00 PM" },
                ],
            },
            seema: {
                role: "ENT Specialist",
                focus: ["Ear, nose & throat care", "Adult & paediatric ENT", "Ear, nose & throat evaluation"],
                timings: [{ d: "Consultation hours", h: "12:00 PM – 2:00 PM & 7:00 PM – 8:00 PM" }],
            },
        },
        gallery: {
            eyebrow: "Inside Signita",
            h2a: "Step inside",
            h2b: "before you walk in.",
            note: "Real photos from the centre — treatment rooms, lab, pharmacy. No stock imagery.",
            captions: [
                "Reception & consultation desk",
                "Pathology lab",
                "In-house pharmacy",
                "Dermatology treatment room",
                "Laser & procedure room",
            ],
        },
        results: {
            eyebrow: "Real results",
            h2a: "Proof, not",
            h2b: "promises.",
            note: "Before & after — shared with patient consent. Individual results may vary.",
            tag: "Real patient",
            before: "Before",
            after: "After",
            cases: ["Acne & skin clearing", "Hair regrowth — male pattern", "Hair regrowth — 8-week programme"],
        },
        appt: {
            eyebrow: "Book a visit",
            h2a: "Reserve your chair.",
            h2b: "We'll confirm the rest.",
            text: "Share a few details and the front desk will call you back to fix a slot with the right specialist. No payment needed to enquire.",
            nameLabel: "Your name",
            namePh: "e.g. Priya Sharma",
            phoneLabel: "Phone number",
            phonePh: "10-digit mobile",
            emailLabel: "Email",
            serviceLabel: "Service needed",
            doctorLabel: "Doctor preference",
            dateLabel: "Preferred date",
            optional: "(optional)",
            msgLabel: "Anything we should know?",
            msgPh: "Briefly describe your concern…",
            submit: "Send enquiry",
            submitting: "Sending…",
            services: [
                "Dermatology & Cosmetology",
                "ENT (Ear, Nose, Throat)",
                "Pathology / Lab Tests",
                "ECG / Cardiac Screening",
                "General OPD Consultation",
            ],
            doctors: ["No preference", "Dr. Swapnil Bhagat (Dermatology)", "Dr. Seema Gupta (ENT)"],
            deskNote: "Front desk — call to confirm today's timings",
            toastOk: "Enquiry received. Our front desk will call you to confirm your slot.",
            toastErr: "Could not send your enquiry",
            toastErrDesc: "Please call us directly on 7208991091.",
            tooMany: "Too many enquiries from this number. Please call us on 7208991091.",
        },
        loc: {
            eyebrow: "Visit us",
            h2a: "Easy to find on",
            h2b: "Ghodbunder Road.",
            directions: "Get directions",
        },
        footer: {
            desc: "Specialised dermatology, ENT and integrated diagnostics on Ghodbunder Road, Thane West — expert care, calmly delivered.",
            explore: "Explore",
            services: "Services",
            contact: "Contact",
            backTop: "Back to top",
        },
        mobile: { call: "Call now", book: "Book visit" },
        wa: { title: "Book on WhatsApp", general: "General enquiry", msgPrefix: "Hi Signita Wellness, I'd like to book:" },
    },
    mr: {
        nav: {
            services: "सेवा",
            doctors: "डॉक्टर",
            gallery: "आमचे केंद्र",
            appointment: "अपॉइंटमेंट",
            location: "पत्ता",
            book: "अपॉइंटमेंट बुक करा",
            toggle: "English",
        },
        hero: {
            eyebrow: "सिग्निटा वेलनेस — ठाणे पश्चिम",
            l1a: "स्किन, कान, नाक व",
            l1b: "घशीच्या",
            l2a: "आजारांसाठी",
            l2b: "जाणकार उपचार.",
            sub: "डॉ. स्वप्निल भगत (डर्मेटॉलॉजी) आणि डॉ. सीमा गुप्ता (ईएनटी) यांच्या देखरेखीखालील विशेष उपचार केंद्र — ओस्कार हॉस्पिटल, कासारवडावली जवळ पॅथॉलॉजी, डिजिटल ईसीजी, सामान्य ओपीडी आणि इन-हाऊस फार्मसी एकाच शांत छताखाली.",
            cta1: "अपॉइंटमेंट बुक करा",
            cta2: "कॉल करा 7208991091",
            stats: [
                { v: "02", l: "मुख्य विशेषता — डर्मेटॉलॉजी व ईएनटी" },
                { v: "06", l: "एकाच छताखाली ओपीडी सेवा" },
                { v: "01", l: "घोडबंदर रोड, ठाणे पश्चिम येथे एकाच पत्त्यावर" },
            ],
            scroll: "पुढे पहा",
            badge1t: "डर्मेटॉलॉजी",
            badge1s: "आमची प्रमुख विशेषता",
            badge2t: "तसेच उपलब्ध",
            badge2s: "ईएनटी · पॅथॉलॉजी · ईसीजी · फार्मसी",
            gReviewsWord: "Google पुनरावलोकने",
        },
        marquee: ["डर्मेटॉलॉजी", "कॉस्मेटॉलॉजी", "ईएनटी सेवा", "पॅथॉलॉजी", "डिजिटल १२-लीड ईसीजी", "इन-हाऊस फार्मसी", "सामान्य ओपीडी"],
        services: {
            eyebrow: "आम्ही काय करतो",
            h2a: "स्किन, इंद्रिय व सर्व तपासण्यांसाठी",
            h2b: "एकाच पत्त्यावर.",
            side: "ठिकाणीच पॅथॉलॉजी, डिजिटल ईसीजी आणि सज्ज फार्मसीसह विशेषज्ञ सल्ला — तुमची भेट उत्तरांसह संपते, धावपळीत नाही.",
            items: {
                derm: {
                    tag: "प्रमुख विशेषता",
                    title: "डर्मेटॉलॉजी व कॉस्मेटॉलॉजी",
                    desc: "क्लिनिकल डर्मेटॉलॉजी, स्किन रिज्युव्हिनेशन, लेझर उपचार, मुरूम व केसांची काळजी — डॉ. स्वप्निल भगत (एमबीबीएस, डीडीव्ही) यांच्या मार्गदर्शनाखाली.",
                    chips: ["मुरूम व डाग", "लेझर व सौंदर्य उपचार", "केसांचे उपचार"],
                },
                ent: {
                    tag: "मुख्य विशेषता",
                    title: "ईएनटी — कान, नाक व घसा",
                    desc: "डॉ. सीमा गुप्ता (एमबीबीएस, एमएस ईएनटी, डीएनबी ईएनटी) यांच्याकडे प्रौढ व मुलांसाठी संपूर्ण कान-नाक-घशा काळजी.",
                },
                path: {
                    tag: "डायग्नोस्टिक ओपीडी",
                    title: "ॲडव्हान्स्ड पॅथॉलॉजी",
                    desc: "संपूर्ण रक्त तपासण्या व विशेष बायोमार्कर्स, जलद अहवाल — केंद्रातच.",
                },
                ecg: {
                    title: "ईसीजी व हृदय तपासणी",
                    desc: "प्रतिबंधात्मक हृदयआरोग्यासाठी डिजिटल १२-लीड ईसीजी व झटपट मूल्यांकन.",
                },
                pharm: {
                    title: "इन-हाऊस फार्मसी",
                    desc: "प्रिस्क्रिप्शनवर खऱ्या डर्मेटॉलॉजिकल मलमपट्ट्या, ईएनटी केअर किट्स व आवश्यक औषधे.",
                },
                opd: {
                    title: "सामान्य ओपीडी",
                    desc: "प्रतिबंधात्मक आरोग्य तपासण्या, तज्ज्ञ दुसरे मत व वैयक्तिक काळजी योजना.",
                    walkin: "वॉक-इन स्वागत",
                },
            },
        },
        why: {
            eyebrow: "सिग्निटा का?",
            h2a: "एक शांत, विचारपूर्वक उभारलेले क्लिनिक —",
            h2b: "तुमच्या वेळेभोवती घडलेले.",
            chipTop: "जवळ",
            chip: "ओस्कार हॉस्पिटल, कासारवडावली",
            points: [
                {
                    title: "थेट विशेषज्ञांकडे",
                    text: "पात्र विशेषज्ञांकडून सल्ला — डर्मेटॉलॉजिस्ट व ईएनटी सर्जन; दरम्यानचा कोणीही नाही.",
                },
                {
                    title: "एकाच छताखाली तपासण्या",
                    text: "पॅथॉलॉजी, डिजिटल १२-लीड ईसीजी आणि सामान्य ओपीडी सल्लाखोलींच्या लगत — अहवालांसाठी दिवस थांबावे लागत नाही.",
                },
                {
                    title: "सहजपणे पूर्ण होणारी भेट",
                    text: "कासारवडावली, घोडबंदर रोडवर ओस्कार हॉस्पिटलच्या अगदी शेजारी — भेट पूर्ण करण्यासाठी इन-हाऊस फार्मसीसह.",
                },
            ],
        },
        doctors: {
            eyebrow: "डॉक्टरांना भेटा",
            h2a: "दोन विशेषज्ञ.",
            h2b: "अंदाजाला जागा नाही.",
            hours: "सेवेच्या वेळा",
            enquire: "चौकशी करा",
            consultNote: "वॉक-इन व अपॉइंटमेंट",
            lead: "प्रमुख विशेषता",
            swapnil: {
                role: "डर्मेटॉलॉजिस्ट व कॉस्मेटॉलॉजिस्ट",
                focus: ["क्लिनिकल डर्मेटॉलॉजी", "स्किन व केसांचे उपचार", "लेझर व सौंदर्य उपचार"],
                timings: [
                    { d: "सोम, मंगळ, गुरु, शुक्र, शनि", h: "दुपारी १२ ते रात्री ९:३०" },
                    { d: "बुधवार", h: "बंद", closed: true },
                    { d: "रविवार", h: "दुपारी १२ ते ७" },
                ],
            },
            seema: {
                role: "ईएनटी विशेषज्ञ",
                focus: ["कान, नाक व घशाची काळजी", "प्रौढ व बाल ईएनटी", "कान, नाक व घशाचे मूल्यांकन"],
                timings: [{ d: "सल्लावेळ", h: "दुपारी १२ ते २ व संध्याकाळी ७ ते ८" }],
            },
        },
        gallery: {
            eyebrow: "आमचे केंद्र",
            h2a: "येण्यापूर्वी",
            h2b: "आतले पहा.",
            note: "केंद्रातील खरे फोटो — उपचार कक्ष, प्रयोगशाळा, फार्मसी. स्टॉक फोटो नाहीत.",
            captions: [
                "स्वागत कक्ष व सल्ला डेस्क",
                "पॅथॉलॉजी प्रयोगशाळा",
                "इन-हाऊस फार्मसी",
                "डर्मेटॉलॉजी उपचार कक्ष",
                "लेझर व उपचार कक्ष",
            ],
        },
        results: {
            eyebrow: "खरे निकाल",
            h2a: "वचने नाही,",
            h2b: "पुरावे.",
            note: "आधी–नंतर — रुग्णांच्या संमतीने प्रकाशित. निकाल व्यक्तीपरत्वे बदलू शकतात.",
            tag: "खरा रुग्ण",
            before: "आधी",
            after: "नंतर",
            cases: ["मुरूम व त्वचा सफाई", "केस वाढ — पुरुष", "केस वाढ — ८ आठवड्यांचा उपचार"],
        },
        appt: {
            eyebrow: "भेट बुक करा",
            h2a: "तुमची जागा राखून ठेवा.",
            h2b: "उर्वरितची काळजी आमची.",
            text: "थोडी माहिती द्या — योग्य विशेषज्ञासोबत वेळ ठरवण्यासाठी फ्रंट डेस्क तुम्हाला कॉल करेल. चौकशीसाठी कोणताही चार्ज नाही.",
            nameLabel: "तुमचे नाव",
            namePh: "उदा. प्रिया शर्मा",
            phoneLabel: "मोबाइल क्रमांक",
            phonePh: "१० अंकी मोबाइल",
            emailLabel: "ईमेल",
            serviceLabel: "हवी असलेली सेवा",
            doctorLabel: "डॉक्टर पसंती",
            dateLabel: "पसंतीची तारीख",
            optional: "(ऐच्छिक)",
            msgLabel: "काही सांगायचे आहे का?",
            msgPh: "तक्रार थोडक्यात सांगा…",
            submit: "चौकशी पाठवा",
            submitting: "पाठवत आहे…",
            services: [
                "डर्मेटॉलॉजी व कॉस्मेटॉलॉजी",
                "ईएनटी (कान, नाक, घसा)",
                "पॅथॉलॉजी / प्रयोगशाळा चाचण्या",
                "ईसीजी / हृदय तपासणी",
                "सामान्य ओपीडी सल्ला",
            ],
            doctors: ["कोणीही", "डॉ. स्वप्निल भगत (डर्मेटॉलॉजी)", "डॉ. सीमा गुप्ता (ईएनटी)"],
            deskNote: "फ्रंट डेस्क — आजच्या वेळा जाणून घेण्यासाठी कॉल करा",
            toastOk: "चौकशी मिळाली. वेळ निश्चितीसाठी आमची फ्रंट डेस्क तुम्हाला कॉल करेल.",
            toastErr: "चौकशी पाठवता आली नाही",
            toastErrDesc: "कृपया थेट 7208991091 वर कॉल करा.",
            tooMany: "या क्रमांकावरून खूप चौकशी आल्या. कृपया 7208991091 वर कॉल करा.",
        },
        loc: {
            eyebrow: "आमच्याकडे या",
            h2a: "घोडबंदर रोडवर",
            h2b: "सहज शोधा.",
            directions: "मार्गदर्शन मिळवा",
        },
        footer: {
            desc: "घोडबंदर रोड, ठाणे पश्चिम येथे विशेष डर्मेटॉलॉजी, ईएनटी व एकत्रित निदान — शांत आणि निष्णात काळजी.",
            explore: "पहा",
            services: "सेवा",
            contact: "संपर्क",
            backTop: "वर जा",
        },
        mobile: { call: "आता कॉल करा", book: "भेट बुक करा" },
        wa: { title: "WhatsApp वर बुक करा", general: "सामान्य चौकशी", msgPrefix: "नमस्कार, मला अपॉइंटमेंट हवे आहे:" },
    },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("signita-lang") || "en");

    useEffect(() => {
        localStorage.setItem("signita-lang", lang);
        document.documentElement.lang = lang === "mr" ? "mr" : "en";
    }, [lang]);

    return (
        <LangContext.Provider value={{ lang, setLang, isMr: lang === "mr", t: messages[lang] }}>
            {children}
        </LangContext.Provider>
    );
}

export const useLang = () => useContext(LangContext);
